import { useMemo } from 'react';

import { useUser } from 'auth/User';

import { PERMISSION_ACTION_IMPERSONATE } from '../actionConstants';

export const useIsImpersonateAllowed = () => {
  const { permissions, user } = useUser();

  return useMemo(
    () =>
      user?.impersonatedBy ||
      permissions?.actionIds?.includes(PERMISSION_ACTION_IMPERSONATE),
    [user, permissions]
  );
};
